import { c as _c } from "react/compiler-runtime";
import type { FetchChatTranslateParams } from '@module/apis/client-side/chat/type';
import Button from '@module/components/Button/Button';
import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';
import type { NormalChatMessage } from '@module/types/centrifuge/public-message';
import useChatTranslate from './useChatTranslate';
interface Props {
  chatData: NormalChatMessage;
  setTranslatedMessage: (message: string) => void;
  filtered?: boolean; // 필터링된 메시지인지 여부
  filteredMessage?: string; // 필터 안내 메세지 ex)금칙어가 포함되어 있습니다.
  className?: string;
  onError: ((error: Error, variables: FetchChatTranslateParams, context: unknown) => Promise<unknown> | unknown) | undefined;
  // 해당 방송의 bj인지 여부
  onClickWithoutLogin: () => void;
  isRoomMaster?: boolean;
}
function ChatTranslateButton(t0) {
  const $ = _c(21);
  const {
    chatData,
    setTranslatedMessage,
    filtered,
    filteredMessage,
    className,
    onError,
    onClickWithoutLogin,
    isRoomMaster
  } = t0;
  let t1;
  if ($[0] !== chatData || $[1] !== filtered || $[2] !== filteredMessage || $[3] !== isRoomMaster || $[4] !== onClickWithoutLogin || $[5] !== onError || $[6] !== setTranslatedMessage) {
    t1 = {
      chatData,
      setTranslatedMessage,
      filtered,
      filteredMessage,
      onError,
      isRoomMaster,
      onUnauthenticated: onClickWithoutLogin
    };
    $[0] = chatData;
    $[1] = filtered;
    $[2] = filteredMessage;
    $[3] = isRoomMaster;
    $[4] = onClickWithoutLogin;
    $[5] = onError;
    $[6] = setTranslatedMessage;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const {
    translate,
    isPending,
    isTranslated
  } = useChatTranslate(t1);
  let t2;
  if ($[8] !== translate) {
    t2 = e => {
      e.stopPropagation();
      translate();
    };
    $[8] = translate;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleClick = t2;
  if (isTranslated) {
    return null;
  }
  let t3;
  if ($[10] !== className) {
    t3 = cn("!bg-transparent ml-2", className, {
      "border-0": SettingConfig.LANG === "ko"
    });
    $[10] = className;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button.Icon name="TranslateFilled" iconSize={12} />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn({
      "font-normal text-[12px] hover:underline": SettingConfig.LANG === "ko"
    });
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <Button.Text className={t5}>{SettingConfig.LANG !== "ko" ? "\u7FFB\u8A33" : "\uBC88\uC5ED"}</Button.Text>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== handleClick || $[17] !== isPending || $[18] !== t3 || $[19] !== t6) {
    t7 = <Button height="small" variant="tertiary" className={t3} onClick={handleClick} isPending={isPending}>{t4}{t6}</Button>;
    $[16] = handleClick;
    $[17] = isPending;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
export default ChatTranslateButton;